module.exports = __webpack_public_path__ + "static/img/pMRI2.cf497721.png";